/* Ambient motion is optional. Links work with JavaScript disabled. */
(() => {
  'use strict';
  if (/(^|\/)[^/]*rolex[^/]*(\/|$)/i.test(window.location.pathname)) return;

  function initialize() {
    document.querySelectorAll('[data-rsc-root]').forEach((root) => {
      if (root.dataset.rscInitialized === 'true') return;
      if (typeof window.matchMedia !== 'function') return;
      root.dataset.rscInitialized = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      function update() {
        root.dataset.motion = visible && !document.hidden && !reduced.matches ? 'playing' : 'paused';
      }
      if (typeof reduced.addEventListener === 'function') reduced.addEventListener('change', update);
      else if (typeof reduced.addListener === 'function') reduced.addListener(update);
      document.addEventListener('visibilitychange', update);
      if ('IntersectionObserver' in window) {
        new window.IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.target === root && entry.isIntersecting);
          update();
        }, { threshold: 0 }).observe(root);
      } else visible = true;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
